import axios from "axios";
import { get } from "lodash";
import refreshAccessToken from "./utils/refreshToken";
import is401, { isGraph401 } from "./utils/refreshToken/is401";
import mfaToken, { isMFARequired, isGraphMFARequired } from "./utils/mfa";
import addGenericHeaders from "./utils/addHeaders";
import genericParseResponse from "./utils/parseResponse";
import removeAuthHeader from "./utils/removeAuthHeader";
import checkForMaintenance from "./utils/checkForMaintenance";
import stripEtag from "./utils/stripEtag";
import genericErrorHandler, { getGraphError as checkForGraphError } from "./utils/errorHandler";
import errorHandlerRegister from "./utils/errorHandler/register";
import setIfNotSet from "../../setIfNotSet";
var API = /** @class */ (function () {
    function API() {
    }
    API.prototype.setTokens = function (accessToken) {
        _accessToken = accessToken;
    };
    API.prototype.clearTokens = function () {
        _accessToken = undefined;
    };
    API.prototype.hasTokens = function () {
        return !!_accessToken;
    };
    API.prototype.request = function (config) {
        return axios
            .request(addHeaders(config))
            .catch(errorHandler)
            .then(parseResponse);
    };
    API.prototype.get = function (url, config) {
        return axios
            .get(url, addHeaders(config))
            .catch(errorHandler)
            .then(parseResponse);
    };
    API.prototype.post = function (url, data, config) {
        return axios
            .post(url, data, addHeaders(config))
            .catch(errorHandler)
            .then(parseResponse);
    };
    API.prototype.put = function (url, data, etag, config) {
        stripEtag(data);
        return axios
            .put(url, data, addHeaders(config, etag))
            .catch(errorHandler)
            .then(parseResponse);
    };
    API.prototype.patch = function (url, data, etag, config) {
        stripEtag(data);
        return axios
            .patch(url, data, addHeaders(config, etag))
            .catch(errorHandler)
            .then(parseResponse);
    };
    API.prototype.head = function (url, config) {
        return axios.head(url, config).catch(errorHandler);
    };
    API.prototype.delete = function (url, etag, config) {
        return axios.delete(url, addHeaders(config, etag)).catch(errorHandler);
    };
    API.prototype.sentryIgnoreError = function (config, arr) {
        setIfNotSet(config, "sentryIgnoreError", arr);
    };
    API.prototype.sentryIgnoreAllErrors = function (config, boolean) {
        if (boolean === void 0) { boolean = true; }
        setIfNotSet(config, "sentryIgnoreAllErrors", boolean);
    };
    API.prototype.registerErrorHandlers = function (handlers) {
        handlers.forEach(function (handler) { return errorHandlerRegister.add(handler); });
    };
    return API;
}());
export default new API();
/**
 * @description: Privately scoping accessToken + refreshToken so they cannot be programaitcally accessed.
 */
var _accessToken;
function addHeaders(config, etag) {
    var options = addGenericHeaders(config, etag);
    if (!options.headers.Authorization && !options.unAuth && _accessToken) {
        options.headers.Authorization = _accessToken;
    }
    return options;
}
function parseResponse(res) {
    if (isGraphMFARequired(res)) {
        return mfaTokenAndReplay(res);
    }
    if (isGraph401(res)) {
        return refreshTokenAndReplay(res);
    }
    genericParseResponse(res);
    return checkForGraphError(res);
}
function errorHandler(err) {
    var useErrorHandler = get(err, "config.useErrorHandler", true);
    var unAuth = get(err, "config.unAuth", false);
    if (isMFARequired(err)) {
        return mfaTokenAndReplay(err);
    }
    if (useErrorHandler && !unAuth && is401(err)) {
        return refreshTokenAndReplay(err);
    }
    removeAuthHeader(err.config);
    checkForMaintenance(err);
    return genericErrorHandler(err);
}
function refreshTokenAndReplay(err) {
    var replayConfig = err.config;
    return refreshAccessToken(err, _accessToken).then(function () {
        replayConfig.headers.Authorization = _accessToken;
        return axios.request(replayConfig);
    });
}
function mfaTokenAndReplay(err) {
    var replayConfig = err.config;
    return mfaToken(err).then(function () {
        replayConfig.headers.Authorization = _accessToken;
        return axios.request(replayConfig);
    });
}
